import { Component } from '@angular/core';

@Component({
  selector: 'stottle-platform-callback',
  template: `<p>callback works!</p>`,
  styles: []
})
export class CallbackComponent {}
